import { useQuery } from '@tanstack/react-query'
import { fetchApi } from '@/common/lib/fetchApi'

export interface CalendarDay {
  date: string
  hours: number
  is_holiday: boolean
  holiday_name: string | null
  is_time_off: boolean
  time_off_type: string | null
  is_weekend: boolean
}

export interface CalendarPayPeriod {
  start_date: string
  end_date: string
}

export interface CalendarMonthResponse {
  year: number
  month: number
  days: CalendarDay[]
  pay_periods: CalendarPayPeriod[]
}

export function useCalendarData(year: number, month: number) {
  return useQuery({
    queryKey: ['calendar', year, month],
    queryFn: () =>
      fetchApi<CalendarMonthResponse>(`/api/calendar/month?year=${year}&month=${month}`),
  })
}
